
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue")
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("LL") : "";
    },
    date2(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      if (!val) return "";
      return String(val).formatMoney();
    }
  },
  computed: {
    lastOperations() {
      return JSON.parse(
        JSON.stringify((this as any).claim.claims_tracks)
      ).splice(0, 5);
    },
    subscriberTasks() {
      return (this as any).claim.claims_tracks
        ? (this as any).claim.claims_tracks.filter(
            (rt: any) => rt.subscriptorId
          )
        : [];
    },
    aonTasks() {
      return (this as any).claim.claims_tracks
        ? (this as any).claim.claims_tracks.filter((rt: any) => rt.adminId)
        : [];
    }
  }
})
export default class ClaimsDetail extends Vue {
  dictionary: any = {};
  statuses: any = [];
  paymentStatuses: any = ["Pendiente", "Aceptado", "Rechazado"];
  title: string = "";
  comment: string = "";
  modalText: string = "Siniestros";
  statusText: string = "";
  claim: any = {
    claims_details: [{}],
    subscriptor: {},
    request: {
      requests_details: [{}],
      currency: {},
      company: {}
    },
    claims_payments: [],
    claims_tracks: []
  };
  pendingPayments: any = [];
  otherPayments: any = [];
  rows: any = [];
  countries: any = [];
  totalPaymentsDolar: any = {};
  totalPayments: any = {};

  statusClass(status) {
    if (status === 1) return "active";
    if (status === 0) return "pending";
    return "inactive";
  }

  async mounted() {
    await this.loadDictionary();
    await this.loadStatuses();
    await this.loadClaim();
    this.loadCountries();
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  async changePaymentStatus(status) {
    let reload = false;
    for (const payment in this.pendingPayments) {
      if (this.pendingPayments[payment].selected) {
        await (this.$root as any)._post(
          `claimspayments/changestatus/${this.pendingPayments[payment].id}/${status}`
        );
        reload = true;
      }
    }

    if (reload) {
      if (status == 1) {
        this.statusText = `EL PAGO DE SINIESTRO HA SIDO APROBADO`;
      } else {
        this.statusText = `EL PAGO DE SINIESTRO HA SIDO RECHAZADO`;
      }
      (this.$refs.modal1 as any).show();

      this.loadClaim();
    }
  }

  selectPayment(ev, key) {
    this.pendingPayments[key].selected = ev.target.checked;
  }

  getCountry(id: string) {
    for (let i: number = 0; i < this.countries.length; i++) {
      if (parseInt(this.countries[i].id) === parseInt(id)) {
        return this.countries[i].title;
      }
    }
    return "";
  }

  async loadClaim() {
    const response: any = await (this.$root as any)._post(
      `claims/one/${this.$route.params.id}`,
      {
        models: "claims_payments"
      }
    );
    this.claim = response.data[0];
    this.pendingPayments = this.claim.claims_payments.filter(
      el => el.status == 0
    );
    this.pendingPayments.forEach(payment => {
      payment.selected = false;
    });
    this.otherPayments = this.claim.claims_payments.filter(
      el => el.status == 1 || el.status == 2
    );
    this.title = `Detalle Siniestro ${this.claim.code}`;
    
    this.totalPaymentsDolar = response.data[0].claims_totals_payments ? response.data[0].claims_totals_payments.find(t => t.currencyId == 1) : {};
    this.totalPayments = response.data[0].claims_totals_payments ? response.data[0].claims_totals_payments.find(t => t.currencyId !== 1) : {};
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  reduce(key: string) {
    if (this.claim.claims_payments) {
      return this.claim.claims_payments.reduce(
        (acc, cur) => acc + (cur[key] ? parseFloat(cur[key]) : 0.0),
        0.0
      );
    } else {
      return 0;
    }
  }
}
